import { ColumnFields } from '../views/index';

export const COLUMNS_VIEW = (
	labelText: Array<any>,
	labelValue: Array<any>,
	icons: Array<string> = [],
	valueType: Array<any> = [],
	valueUnit: Array<any> = [],
	rowClass: Array<string> = [],
	labelTextClass: Array<string> = [],
	labelValueClass: Array<string> = [],
	iconClass: Array<string>,
	labelValueFlexLayout: Array<string> = []
): Array<ColumnFields> => {
	let results: Array<ColumnFields> = [];
	try {
		labelText.map((label, index) => {
			let row = {} as ColumnFields;
			row.labelText = label;
			row.labelValue = labelValue[index];
			row.icon = icons.length > 0 ? icons[index] : '';
			row.valueType = valueType[index];
			row.valueUnit = valueUnit.length > 0 ? valueUnit[index] : '';
			if (rowClass.length > 0 && rowClass.length == 1) {
				row.rowClass = rowClass[0];
			} else if (rowClass.length > 1) {
				row.rowClass = rowClass[index];
			} else {
				row.rowClass = '';
			}

			if (labelTextClass.length > 0 && labelTextClass.length == 1) {
				row.labelTextClass = labelTextClass[0];
			} else if (labelTextClass.length > 1) {
				row.labelTextClass = labelTextClass[index];
			} else {
				row.labelTextClass = '';
			}

			if (labelValueClass.length > 0 && labelValueClass.length == 1) {
				row.labelValueClass = labelValueClass[0];
			} else if (labelValueClass.length > 1) {
				row.labelValueClass = labelValueClass[index];
			} else {
				row.labelValueClass = '';
			}

			if (iconClass.length > 0 && iconClass.length == 1) {
				row.iconClass = iconClass[0];
			} else if (iconClass.length > 1) {
				row.iconClass = iconClass[index];
			} else {
				row.iconClass = '';
			}

			if (labelValueFlexLayout.length > 0 && labelValueFlexLayout.length == 1) {
				row.labelValueFlexLayout = labelValueFlexLayout[0];
			} else if (labelValueFlexLayout.length > 1) {
				row.labelValueFlexLayout = labelValueFlexLayout[index];
			} else {
				row.labelValueFlexLayout = 'center center';
			}

			results.push(row);
		});
	} catch (error) {
		console.log('COLUMNS_VIEW error: ', error);
	}

	return results;
};
